import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import Article from 'src/smoothr-web-app-core/models/Article';
import ArticleGroup from 'src/smoothr-web-app-core/models/ArticleGroup';
import ArticleOption from 'src/smoothr-web-app-core/models/ArticleOption';
import OptionGroup from 'src/smoothr-web-app-core/models/OptionGroup';
import Order from 'src/smoothr-web-app-core/models/Order';
import { filterMatchingOptions } from 'src/smoothr-web-app-core/utils/order-utils';
import { sleep } from 'src/smoothr-web-app-core/utils/utils';

@Component({
	selector: 'app-show-remove-ingrediants-dialog',
	templateUrl: './show-remove-ingrediants-dialog.component.html',
	styleUrls: ['./show-remove-ingrediants-dialog.component.scss'],
})
export class ShowRemoveIngrediantsDialogComponent implements OnInit {
	public optionGroup: OptionGroup;
	public order: Order;
	public articleGroup: ArticleGroup;
	public listOfArticleOptions: ArticleOption[] = [];
	filterMatchingOptions = filterMatchingOptions;
	constructor(private modalCtrl: ModalController) {}
	static async show(
		modalCtrl: ModalController,
		optionGroup: OptionGroup,
		articleGroup: ArticleGroup,
		order: Order
	): Promise<{ data: ArticleOption[] }> {
		const modal = await modalCtrl.create({
			cssClass: 'eight_height',
			component: ShowRemoveIngrediantsDialogComponent,
			componentProps: {
				optionGroup,
				order,
				articleGroup,
			},
			showBackdrop: true,
			backdropDismiss: true,
		});
		await modal.present();
		const result = (await modal.onDidDismiss()).data;
		await sleep(200);
		return result;
	}

	ngOnInit() {
		this.listOfArticleOptions = this.filterMatchingOptions(
			this.articleGroup.groups,
			this.optionGroup,
			{ times: 0, dependsOn: null, dependency: null }
		);
	}
	addOption(event: ArticleOption) {
		const foundIndex = this.listOfArticleOptions.findIndex(it => it.article._id === event.article._id);
		if (foundIndex >= 0) {
			this.listOfArticleOptions.splice(foundIndex, 1);
		} else {
			this.listOfArticleOptions.push(event);
		}
		// trigger change detection if necessary (though simple array mutation might not be enough if binding relies on immutable reference, but ionic often handles this)
		// For safety, let's create a new reference
		this.listOfArticleOptions = [...this.listOfArticleOptions];
	}
	select() {
		const originalOptions = this.filterMatchingOptions(
			this.articleGroup.groups,
			this.optionGroup,
			{ times: 0, dependsOn: null, dependency: null }
		);

		const changes: ArticleOption[] = [];

		// Find added items
		this.listOfArticleOptions.forEach(opt => {
			if (!originalOptions.find(orig => orig.article._id === opt.article._id)) {
				// It's new. Ensure quantity is 1 for addition.
				// Clone to be safe, though not strictly required if event creation is clean.
				const addition = new ArticleOption();
				Object.assign(addition, opt);
				addition.quantity = 1;
				changes.push(addition);
			}
		});

		// Find removed items
		originalOptions.forEach(opt => {
			if (!this.listOfArticleOptions.find(curr => curr.article._id === opt.article._id)) {
				// It was removed. Create an option with negative quantity.
				const removal = new ArticleOption();
				Object.assign(removal, opt);
				removal.quantity = -1;
				changes.push(removal);
			}
		});

		this.modalCtrl.dismiss({
			data: changes,
		});
	}
	close() {
		this.modalCtrl.dismiss();
	}
}
